<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
    import CustomInteractionDefault from './CustomInteractionDefault.svelte';
    import { getContext } from 'svelte';

    const itemRunnerConfigContext = getContext('itemRunnerConfig') || {};
    const hideTooltips = !!itemRunnerConfigContext.options?.hideTooltips;

    export let properties = {};
    properties.hideTooltips = hideTooltips;
</script>

<style>
    @media print {
        :global-nested {
            & .textReaderInteraction {
                & .tr-pages {
                    height: auto !important; /* `height is set as inline style */
                    overflow: visible !important;
                    border: none !important;
                    background: none !important;
                }
                & .tr-pages-wrap {
                    border: none !important;
                }
                & .tr-page {
                    display: block !important;
                    box-shadow: none !important;
                    border: none !important;
                    border-bottom: var(--border-thin) solid var(--color-border-default) !important;
                }
                & .tr-page:first-child {
                    border-top: var(--border-thin) solid var(--color-border-default) !important;
                }
                & .tr-passage {
                    height: auto !important; /* height is set as inline style */
                }
                & .tr-tab-buttons,
                & .js-nav-container {
                    display: none !important;
                }
            }
        }
    }
</style>

<CustomInteractionDefault {...$$restProps} {properties} />
